// Central configuration registry for Master Admin page table mappings
// Format: route_path -> [database.table, database.table, ...]

export const ADMIN_PAGE_TABLES = {
  // User Management
  '/super/users': [
    'way2connect.users',
    'way2connect.user_roles',
    'way2connect.roles',
    'way2connect.permissions',
    'way2connect.role_permissions',
    'way2connect.user_permission_overrides',
    'way2connect.user_entity_mapping',
    'way2connect.plans',
    'way2connect.user_plan_subscriptions',
    'way2connect.balances'
  ],
  
  // DLT Entities
  '/super/dlt/entities': [
    'way2connect.entities',
    'way2connect.headers',
    'way2connect.user_entity_mapping',
    'way2connect.users'
  ],
  
  // DLT Headers
  '/super/dlt/headers': [
    'way2connect.headers',
    'way2connect.entities',
    'way2connect.template_header_mapping',
    'way2connect.users'
  ],
  
  // DLT Templates
  '/super/dlt/templates': [
    'way2connect.templates',
    'way2connect.entities',
    'way2connect.template_header_mapping',
    'way2connect.headers'
  ],
  
  // Plans
  '/super/plans': [
    'way2connect.plans',
    'way2connect.user_plan_subscriptions',
    'way2connect.user_plan_mapping',
    'way2connect.sms_plans',
    'way2connect.plan_http_routes',
    'way2connect.plan_smpp_mappings'
  ],
  
  // HTTP Routing
  '/admin/http-routing': [
    'way2connect.plan_http_routes',
    'way2connect.http_routes',
    'way2connect.entity_http_routing',
    'way2connect.entities',
    'way2connect.plans'
  ],
  
  // HTTP Routes
  '/admin/http-routes': [
    'way2connect.http_routes',
    'way2connect.plan_http_routes'
  ],
  
  // Recharge
  '/super/recharge': [
    'way2connect.recharge_requests',
    'way2connect.recharge_history',
    'way2connect.balances',
    'way2connect.balance_transactions',
    'way2connect.users'
  ],
  
  // Reports - Detailed
  '/super/report/detailed': [
    'way2connect_reporting.sms_reports',
    'way2connect_reporting.sms_report_summary',
    'way2connect.users',
    'way2connect.entities',
    'way2connect.headers'
  ],
  
  // Reports - Summary
  '/super/report/summary': [
    'way2connect_reporting.sms_report_summary',
    'way2connect_reporting.sms_reports_daily',
    'way2connect_reporting.user_monthly_sms_summary',
    'way2connect.users'
  ],
  
  // Reports - DLR
  '/super/report/dlr': [
    'way2connect_reporting.sms_reports',
    'way2connect_reporting.smpp_delivery_receipts',
    'way2connect_reporting.callback_dlr_logs',
    'way2connect.users'
  ],
  
  // Role Management - Roles
  '/super/role/roles': [
    'way2connect.roles',
    'way2connect.role_permissions',
    'way2connect.permissions'
  ],
  
  // Role Management - User Roles
  '/super/role/user-roles': [
    'way2connect.user_roles',
    'way2connect.users',
    'way2connect.roles',
    'way2connect.user_permission_overrides'
  ],
  
  // Role Management - Permissions
  '/super/role/permissions': [
    'way2connect.permissions',
    'way2connect.role_permissions',
    'way2connect.user_permission_overrides'
  ],
  
  // Telegram Alerts
  '/super/alerts/telegram': [
    'way2connect.alert_definitions',
    'way2connect.alert_rules',
    'way2connect.alert_subscriptions',
    'way2connect.alert_throttle_state',
    'way2connect.telegram_bots',
    'way2connect.telegram_channels',
    'way2connect.users'
  ],
  
  // Keyword Blocking
  '/admin/global-settings/keyword-blocking': [
    'way2connect.keyword_block_rules',
    'way2connect.keyword_replacements',
    'way2connect.users'
  ],
  
  // Mobile Blocking
  '/admin/global-settings/mobile-blocking': [
    'way2connect.mobile_block_rules',
    'way2connect.users'
  ],
  
  // Database Tables
  '/admin/database-tables': [
    'information_schema.tables',
    'information_schema.columns'
  ],
  
  // Worker Dashboard
  '/admin/workers': [
    'way2connect.workers',
    'way2connect.worker_metrics',
    'way2connect.worker_logs',
    'way2connect.worker_queues',
    'way2connect.worker_alerts',
    'way2connect.worker_runtime',
    'way2connect.worker_error_logs',
    'way2connect.worker_message_stats',
    'way2connect.worker_sms_flow_logs',
    'way2connect_worker.service_registry'
  ],
  
  // SMPP Management - Overview
  '/super/smpp': [
    'way2connect.smpp_connectors',
    'way2connect.smpp_connections',
    'way2connect.smpp_connector_status',
    'way2connect.smpp_connector_logs',
    'way2connect.plan_smpp_mappings'
  ],
  
  // SMPP - Connections
  '/super/smpp/connections': [
    'way2connect.smpp_connectors',
    'way2connect.smpp_connections',
    'way2connect.smpp_connection_history',
    'way2connect.smpp_connection_test_logs',
    'way2connect.smpp_socket_status'
  ],
  
  // SMPP - Routes / Mappings
  '/super/smpp/routes': [
    'way2connect.plan_smpp_mappings',
    'way2connect.smpp_connectors',
    'way2connect.plan_route_mappings',
    'way2connect.plans'
  ],
  
  // SMPP - DLR Monitoring
  '/super/smpp/dlr-monitoring': [
    'way2connect_reporting.smpp_delivery_receipts',
    'way2connect_reporting.smpp_submit_responses',
    'way2connect_reporting.smpp_error_code_mapping',
    'way2connect.smpp_connectors'
  ],
  
  // SMPP - Logs
  '/super/smpp/logs': [
    'way2connect.smpp_connector_logs',
    'way2connect.smpp_connection_history',
    'way2connect.smpp_connection_test_logs',
    'way2connect.smpp_dlt_context'
  ],
  
  // Kafka Status (reads from Kafka brokers, no DB tables)
  '/master-admin/kafka-status': [
    'Kafka Brokers (live connection)',
    'way2connect_worker.sms_ingest_requests'
  ],
  
  // DLR Summary Cron
  '/master-admin/dlr-summary-cron': [
    'way2connect_reporting.sms_report_summary',
    'way2connect_reporting.sms_reports',
    'way2connect_reporting.dlr_summary_cron_log',
    'way2connect.users'
  ],
  
  // IP Security & Whitelist
  '/master-admin/ip-whitelist': [
    'way2connect.ip_whitelist_requests',
    'way2connect.ip_whitelist',
    'way2connect.ip_whitelist_audit_log',
    'way2connect.ip_global_blacklist',
    'way2connect.ip_global_whitelist',
    'way2connect.ip_country_rules',
    'way2connect.ip_user_blacklist',
    'way2connect.ip_security_audit_log',
    'way2connect.users'
  ],
  
  // Master Admin Dashboard
  '/master-admin/dashboard': [
    'way2connect.users',
    'way2connect.balances',
    'way2connect_reporting.sms_reports',
    'way2connect_reporting.sms_report_summary',
    'way2connect.smpp_connectors',
    'way2connect.smpp_connector_status'
  ],
  
  // Settings (User)
  '/user/settings': [
    'way2connect.contact_persons',
    'way2connect.phone_verifications',
    'way2connect.ip_whitelist_requests',
    'way2connect.ip_whitelist',
    'way2connect.users'
  ],
  
  // Email Templates
  '/super/email-templates': [
    'way2connect.email_templates',
    'way2connect.email_accounts'
  ],
  
  // Audit Logs
  '/super/audit-logs': [
    'way2connect.audit_logs',
    'way2connect.auth_audit_log',
    'way2connect.api_logs',
    'way2connect.users'
  ],
  
  // Balance Management
  '/super/balance': [
    'way2connect.balances',
    'way2connect.balance_transactions',
    'way2connect.balance_holds',
    'way2connect.balance_alert_rules',
    'way2connect.balance_alert_history',
    'way2connect.user_pricing',
    'way2connect.user_pricing_history',
    'way2connect.users'
  ],

  // Dev Monitor (reads system metrics, no specific DB tables)
  '/master-admin/dev-monitor': [
    'way2connect.worker_metrics',
    'way2connect.worker_error_logs',
    'way2connect.worker_runtime',
    'way2connect.api_logs'
  ]
};

// Helper function to get tables for a specific route
export const getTablesForRoute = (route) => {
  return ADMIN_PAGE_TABLES[route] || [];
};

// Helper function to check if a route has table mappings
export const hasTableMappings = (route) => {
  return route in ADMIN_PAGE_TABLES;
};
